import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=9422de22&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=9422de22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9422de22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9422de22')) {
      api.createRecord('9422de22', component.options)
    } else {
      api.reload('9422de22', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=9422de22&scoped=true&", function () {
      api.rerender('9422de22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/TermsAndConditions.vue"
export default component.exports